import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface CategoryTileProps {
  title: string;
  icon?: LucideIcon;
  imageSrc?: string;
  altText: string;
  href: string;
  className?: string;
  featured?: boolean;
}

export function CategoryTile({
  title,
  icon: Icon,
  imageSrc,
  altText,
  href,
  className,
  featured = false,
}: CategoryTileProps) {
  return (
    <Link
      to={href}
      className={cn(
        'group relative overflow-hidden rounded-lg bg-card transition-all hover:shadow-lg',
        featured ? 'col-span-2 row-span-2' : 'col-span-1',
        className
      )}
    >
      {imageSrc ? (
        <div className="relative aspect-square w-full overflow-hidden">
          <img
            src={imageSrc}
            alt={altText}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-linear-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-lg font-semibold text-white">{title}</h3>
          </div>
        </div>
      ) : (
        <div className="flex aspect-square w-full flex-col items-center justify-center gap-4 bg-muted p-6">
          {Icon && <Icon className="h-8 w-8" />}
          <h3 className="text-lg font-semibold">{title}</h3>
        </div>
      )}
    </Link>
  );
} 